import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buy-back',
  templateUrl: './buy-back.component.html',
  styleUrls: ['./buy-back.component.scss']
})
export class BuyBackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
